import styled from 'styled-components';
import { THEME } from '../../../../../themes';
import {
  CaptionFont,
  HeadlineFont,
} from '../../../../../themes/fonts';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const  Label = styled.div`
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  margin-bottom: ${THEME.SPACING.MICRO};
  ${CaptionFont};
`;

export const  Title = styled.span`
  ${HeadlineFont};
  font-weight: normal;
  margin-bottom: -30px;
`;

export const MarkedTitle = styled.span`
  font-weight: 600;
  margin-left: ${THEME.SPACING.MICRO};
`;

export const RolesListWrapper = styled.div`
  margin-top: -30px;
`;
